import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import reportQmaRepository from '@/shared/http/repositories/business/qmaReportRepository.js'
// import aprReport from '@/shared/http/repositories/business/aprReport'

export default {
  name: 'qmaReportReport',
  components: {},
  mixins: [ActionsForm],
  props: ['report'],
  data () {
    return {
      formSearch: {},
      dataQuatitativos: {},
      contagem: 0,
      totalRelatorio: 0
    }
  },
  mounted () {
  },
  methods: {
    onLoad () {
      loading.push()
      reportQmaRepository.GetRelatorioQuantidadeQMA({formSearch: this.formSearch, Fluxo: this.report})
        .then(Response => {
          this.totalRelatorio = Response.data.qma
          this.contagem = Response.data.qmaPendetes
          loading.pop()
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaReport/components/qmaReportTable/components/qmaPainelReport/qmaPainelReport.js